import { render, staticRenderFns } from "./RedirectClient.vue?vue&type=template&id=25fd16a4&scoped=true"
import script from "./RedirectClient.vue?vue&type=script&lang=js"
export * from "./RedirectClient.vue?vue&type=script&lang=js"
import style0 from "./RedirectClient.vue?vue&type=style&index=0&id=25fd16a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fd16a4",
  null
  
)

export default component.exports